import { useEffect, useState } from "react";
import withLoader from "../../../../components/layouts/WithLoader";
import ProductionOrderService from "../../../../services/Production/ProductionOrderService";
import PopupExecutionProducts from "./PopupExecutionProducts";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import UtilsFormule from "../../../../utils/UtilsFormule";
import uploadAndDownloadService from "../../../../services/uploadAndDownloadFile";
import DataTableAssemblyComponentsWorkOrder from "../productionOrder/pages/DataTableAssemblyComponentsWorkOrder";
import DataTableAssemblyComponentsDechetsWorkOrder from "../productionOrder/pages/DataTableAssemblyComponentsDechetsWorkOrder";
// import StartOperationProduction from "../productionOrder/models/StartOperationProduction";
// import $ from "jquery";
import PopupFinishExecutionProducts from "./PopupFinishExecutionProducts";

const DetailsOperationExecution = ({ startLoading, stopLoading }) => {
  const [workOrder, setWorkOrder] = useState(null);
  const [time, setTime] = useState({ minutes: 0, seconds: 0 });
  const [onStartOperation, setOnStartOperation] = useState(false);

  const [isActive, setIsActive] = useState(false);
  const [onAddPopupExecution, setOnAddPopupExecution] = useState(false);
  const [onFinishPopupExecution, setOnFinishPopupExecution] = useState(false);

  const [bom, setBom] = useState([]);
  const [dechets, setDechets] = useState([]);
  const [avancementBtn, setAvancementBtn] = useState(false);
  const [startDate, setStartDate] = useState();
  const [testQte, setTestQte] = useState(true);

  useEffect(() => {
    startLoading();
    ProductionOrderService.getWorkOrderById(
      getCurrentUserId(),
      localStorage.getItem("idWorkOrder")
    )
      .then((response) => {
        console.log("getWorkOrderById", response.data.success);
        setWorkOrder(response.data.success);
        setBom(response.data.bom);
        response.data.bom &&
        response.data.bom.map((element) => {
          if (
            element.assemblyComponentsWorkOrder.quantityDemande >
            element.quantityInStock
          ) {
            setTestQte(false);
          }
        });
        setDechets(response.data.dechet);
      })
      .catch((e) => {
        alert("problème de connexion");
      })
      .finally(() => {
        stopLoading();
      });
  }, []);
  //   const formatDate = () => {
  //     const now = new Date();
  //     const year = now.getFullYear();
  //     const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  //     const day = String(now.getDate()).padStart(2, '0');
  //     const hours = String(now.getHours()).padStart(2, '0');
  //     const minutes = String(now.getMinutes()).padStart(2, '0');
  //     const seconds = String(now.getSeconds()).padStart(2, '0');

  //     const dateFormated=`${year}/${month}/${day}T${hours}:${minutes}:${seconds}`;
  //     setStartDate(dateFormated)
  // };

  useEffect(() => {
    let interval = null;

    if (isActive) {
      interval = setInterval(() => {
        setTime((prevTime) => {
          const newSeconds = prevTime.seconds + 1;
          const newMinutes =
            newSeconds >= 60 ? prevTime.minutes + 1 : prevTime.minutes;

          return {
            minutes: newMinutes,
            seconds: newSeconds >= 60 ? 0 : newSeconds,
          };
        });
      }, 1000);
    } else if (!isActive && (time.minutes !== 0 || time.seconds !== 0)) {
      setOnAddPopupExecution(true);
      // clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isActive, time]);

  //   useEffect(() => {
  //     let interval;

  //     if (isRunning) {
  //         interval = setInterval(() => {
  //             setTime(prevTime => prevTime + 1);
  //         }, 1000);
  //     }

  //     return () => clearInterval(interval);
  // }, [isRunning]);
  useEffect(() => {
    if (time.seconds >= 3600) {
      // 3600 seconds = 60 minutes
      // setOnAddPopupExecution(true);
      setAvancementBtn(true);
      setIsActive(false); // Stop the stopwatch
    }
  }, [time]);

  const toggle = () => setIsActive(!isActive);
  const reset = () => {
    setIsActive(false);
    setTime({ minutes: 0, seconds: 0 });
  };

  const testAvancement = () => {
    if (workOrder?.state === "PENDING") {
      return <span className="badge bg-danger">en attente</span>;
    } else if (workOrder?.state === "STARTED") {
      return <span className="badge bg-primary">en cours</span>;
    } else if (workOrder?.state === "FINISHED") {
      return <span className="badge bg-success">terminé</span>;
    }
  };
  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch((error) => {
        // setOpenErrorAlert(true);
        // setErrorAlertText("Erreur : "+error);
      });
  };

  const handleStartWorkOrder = () => {
    setOnStartOperation(true);
  };
  const handlePauseWorkOrder = () => {
    setOnAddPopupExecution(true);
  };

  const handleTerminerWorkOrder = () => {
    setOnFinishPopupExecution(true);
  };

  const startOperation = () => {
    ProductionOrderService.startWorkOrder(
      getCurrentUserId(),
      localStorage.getItem("idWorkOrder")
    )
      .then((response) => {
        console.log("getWorkOrderById", response.data.success);
        setWorkOrder(response.data.success);
        setIsActive(!isActive);
        setStartDate(UtilsFormule.formatDateForBackend(new Date())); // setOpenAlert(true);
        // setOnStartOperation(false);
      })
      .catch((e) => {
        alert("problème de connexion");
      });
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <div className="row">
                {" "}
                <div className="col-sm-9">
                  <h3 className="card-title">L'ordre de production : </h3>{" "}
                  {workOrder?.productionOrder &&
                    workOrder?.productionOrder.code}{" "}
                  {workOrder?.productionOrder &&
                    workOrder?.productionOrder.name}
                </div>
                {workOrder?.productionOrder && (
                  <div className="col-sm-3">
                    Date limite :
                    {UtilsFormule.formatDateHours(
                      workOrder?.productionOrder?.scheduledDate
                    )}
                  </div>
                )}
              </div>
            </div>{" "}
            <div className="card-body">
              <label> Produit: </label> {workOrder?.product.productCode}-
              {workOrder?.product.barcode}-{workOrder?.product.name} <br />
              <label> Quantité à produire : </label> {workOrder?.quantity}
              <br />
              <label> Quantité produite : </label> {workOrder?.quantityProduite}
              <br />

                    <label>
                      Quantité Dechet : {workOrder?.quantityProduiteDechet}{" "}
                    </label>
                    <br/>
              <label> les composants </label>
              {bom.length > 0 && (
                <DataTableAssemblyComponentsWorkOrder listComponents={bom} />
              )}
              <br />
              <label>Les déchets</label>
              <DataTableAssemblyComponentsDechetsWorkOrder
                listComponents={dechets}
              />
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="row">
                {" "}
                <div className="col-sm-6">
                  <h3 className="card-title">
                    Operation : {workOrder?.operationDetails.operation.code}-
                    {workOrder?.operationDetails.operation.name}
                  </h3>{" "}
                </div>
                <div className="col-sm-3"> </div>
                <div className="col-sm-3">
                  Date limite :
                  {UtilsFormule.formatDateHours(workOrder?.scheduledDate)}
                </div>
              </div>
            </div>{" "}
            <div className="card-body">
              <label>Station de travail :</label> {workOrder?.workstation.code}-{" "}
              {workOrder?.workstation.name}
              <br />
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Operation</th>
                    <th>SETUP TIME (s)</th>
                    <th>transfert TIME (s)</th>
                    <th>Avancement</th>
                    <th>Guide</th>
                  </tr>
                </thead>
                <tbody>
                  {workOrder?.operationDetails && (
                    <tr>
                      <td>
                        {workOrder?.operationDetails.operation.code}-
                        {workOrder?.operationDetails.operation.name}
                      </td>
                      <td>{workOrder?.operationDetails.setupTime}</td>
                      <td>{workOrder?.operationDetails.transferTime}</td>

                      <td>{testAvancement()}</td>
                      <td>
                        {" "}
                        <button
                          style={{ width: 40 }}
                          class="btn bg-gray btn-sm "
                          disabled={
                            workOrder?.operationDetails.operation.path === "any"
                          }
                          onClick={() =>
                            onShowFileInOtherWizndowHandler(
                              workOrder?.operationDetails.operation.path
                            )
                          }
                        >
                          <i class="fas fa-eye"></i>
                        </button>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="row">
                {" "}
                <div className="col-sm-6">
                  <h3 className="card-title">Execution:</h3>{" "}
                </div>
                <div className="col-sm-6">
                  {" "}
                  <h3 className="card-title float-right">
                    Date début actuel de la production :{" "}
                    {UtilsFormule.formatDateHours(workOrder?.actualStartDate)}
                  </h3>{" "}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6"></div>
                <div className="col-sm-6">
                  {" "}
                  {workOrder?.actualEndDate && (
                    <h3 className="card-title float-right">
                      Date fin actuel de la production :{" "}
                      {UtilsFormule.formatDateHours(workOrder?.actualEndDate)}
                    </h3>
                  )}{" "}
                </div>
              </div>
            </div>
            {workOrder?.state !== "FINISHED" && testQte&& (
              <div className="row">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-5"></div>
                    <div className="col-sm-2">
                      <h1>
                        {String(time.minutes).padStart(2, "0")}:
                        {String(time.seconds).padStart(2, "0")}
                      </h1>
                    </div>
                    <div className="col-sm-5"></div>
                  </div>
                  <div className="row">
                    <div className="col-sm-2">
                      {/* isActive */}
                      <button
                        type="button"
                        className="btn btn-default"
                        // data-toggle="modal"
                        // data-target="#start-operation"
                        onClick={startOperation}
                        // onClick={handleStartWorkOrder}
                        disabled={isActive || avancementBtn}
                      >
                        <>
                          <i className="fas fa-play" /> Commencer
                        </>
                      </button>
                    </div>
                    <div className="col-sm-2">
                      <button
                        type="button"
                        data-toggle="modal"
                        data-target="#execution-production"
                        className="btn btn-default"
                        // onClick={toggle}
                        onClick={handlePauseWorkOrder}
                        disabled={!isActive || avancementBtn}
                      >
                        <>
                          <i className="fas fa-pause" /> Pause
                        </>
                      </button>
                    </div>

                    <div className="col-sm-2">
                      <button
                        type="button"
                        data-toggle="modal"
                        data-target="#execution-production"
                        className="btn btn-danger"
                        // onClick={reset}
                        disabled={!isActive || avancementBtn}
                        onClick={handleTerminerWorkOrder}
                      >
                        <i class="fas fa-stop"></i> Terminer
                      </button>
                    </div>

                    {avancementBtn && (
                      <div className="col-sm-2">
                        <button
                          type="button"
                          data-toggle="modal"
                          data-target="#execution-production"
                          className="btn btn-success"
                          // onClick={reset}
                          onClick={handlePauseWorkOrder}

                          // disabled={avancementBtn}
                        >
                          <i class="fas fa-pen"></i> Pointage
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
             {testQte === false && (
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  Certains produits ne sont pas en stock
                </h5>
              </div>
            </div>
          )}

          </div>
        </div>
      </section>
      {/* {onStartOperation && (
        
        <StartOperationProduction
          setOnStartOperation={setOnStartOperation}
          setWorkOrder={setWorkOrder}
          setIsActive={setIsActive}
          isActive={isActive}
          setDechets={setDechets}
          setBom={setBom}
          bom={bom}
          dechets={dechets}
        />
      )} */}

      {/* {onAddPopupExecution && (
        <PopupExecutionProducts
          setOnAddPopupExecution={setOnAddPopupExecution}
        />
      )} */}

      {onAddPopupExecution && (
        <PopupExecutionProducts
          setAvancementBtn={setAvancementBtn}
          setOnAddPopupExecution={setOnAddPopupExecution}
          setDechets={setDechets}
          setBom={setBom}
          setWorkOrder={setWorkOrder}
          // bom={bom}
          dechets={dechets}
          workOrder={workOrder}
          reset={reset}
          startDate={startDate}
          setStartDate={setStartDate}
        />
      )}
      {onFinishPopupExecution && (
        <PopupFinishExecutionProducts
          setAvancementBtn={setAvancementBtn}
          setOnFinishPopupExecution={setOnFinishPopupExecution}
          setDechets={setDechets}
          setBom={setBom}
          // setBom={setBom}
          setWorkOrder={setWorkOrder}
          // bom={bom}
          dechets={dechets}
          workOrder={workOrder}
          reset={reset}
          startDate={startDate}
          setStartDate={setStartDate}
        />
      )}
    </div>
  );
};
export default withLoader(DetailsOperationExecution);
